// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import FullLogEventModal from './full_log_event_modal';

export default FullLogEventModal;
